var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 60,
    viewBox: "0 0 59 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.344681 9.99842C0.346859 4.93651 4.45159 0.834505 9.5135 0.835694L49.5021 0.845097C54.5639 0.846287 58.6666 4.94999 58.6666 10.0118V50.0044C58.6666 55.0646 54.5663 59.1676 49.5061 59.171L9.50944 59.1733C4.44939 59.1733 0.346401 55.0732 0.342773 50.0132L0.344681 9.99842ZM40.5539 54.1733L19.0088 30.2294C17.4119 28.4547 14.6534 28.382 12.9652 30.0702L5.33395 37.7014L5.34277 50.0096C5.34442 52.3096 7.20942 54.1733 9.50944 54.1733H40.5539ZM30.3332 23.3333C30.3332 18.2706 34.4373 14.1666 39.4999 14.1666C44.5625 14.1666 48.6665 18.2706 48.6665 23.3333C48.6665 28.3959 44.5625 32.4999 39.4999 32.4999C34.4373 32.4999 30.3332 28.3959 30.3332 23.3333Z",
    fill: "url(#paint0_linear_2413_758)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2413_758",
    x1: 0.384673,
    y1: 30.0045,
    x2: 58.7085,
    y2: 30.0045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D802BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B7DB1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMedia);
export default __webpack_public_path__ + "static/media/icon_media.a93fc92bd393c8c3186161f8746e71fe.svg";
export { ForwardRef as ReactComponent };